import { generateWrapUpMessage } from '../blurbs';

import type { IUseWrapUpProps, IWrapUpValues } from '../types';

export const useWrapUp = ({
  closeModal,
  handleSubmit,
  whichPerson,
  otherPerson,
}: IUseWrapUpProps) => {
  const initialValues: IWrapUpValues = {
    hasQuestions: null,
    questions: '',
    reminderTakeReadingsRegularly: [],
    reminderMonitorHealthConditions: [],
    needConsumables: null,
    verifiedAddress: [],
    transferCallToNursingTeam: [],
    additionalDetails: '',
    whichPerson,
    otherPerson,
    goalToUseDevice: '',
    goalToUseDeviceOther: '',
  };

  const preparedData = (data: IWrapUpValues) => {
    const formData = Object.fromEntries(
      Object.entries(data).filter(([_, value]) => value !== null),
    );

    return {
      hasQuestions: formData.hasQuestions,
      questions: formData.questions,
      reminderTakeReadingsRegularly: formData.reminderTakeReadingsRegularly,
      reminderMonitorHealthConditions: formData.reminderMonitorHealthConditions,
      needConsumables: formData.needConsumables,
      verifiedAddress: formData.verifiedAddress,
      transferCallToNursingTeam: formData.transferCallToNursingTeam,
      additionalDetails: formData.additionalDetails,
      whichPerson: formData.whichPerson,
      otherPerson: formData.otherPerson,
      goalToUseDevice: formData.goalToUseDevice,
      goalToUseDeviceOther: formData.goalToUseDeviceOther,
    };
  };

  const onSaveForm = (formData: IWrapUpValues) => {
    const preparedValues = preparedData(formData);

    const filteredValues = Object.fromEntries(
      Object.entries(preparedValues).filter(([_, value]) => value !== null),
    ) as IWrapUpValues;

    const message = generateWrapUpMessage(filteredValues);

    handleSubmit(message);
    closeModal();
  };

  return {
    initialValues,
    onSaveForm,
  };
};
